"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _selectors = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var R = _interopRequireWildcard(require("ramda"));
var _html = require("../../../../helpers/html");
var _actions = require("../../../../bus/ui/actions");
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _Loader = _interopRequireDefault(require("../../../ui/Loader"));
var _constants = require("../../store/constants");
var _actions2 = require("../../store/actions");
var _selectors2 = require("../../store/selectors");
var _List = _interopRequireDefault(require("../List"));
var _Collection = _interopRequireDefault(require("../Collection"));
var _CreateCollectionButton = _interopRequireDefault(require("./components/CreateCollectionButton"));
var _modalStyles = _interopRequireDefault(require("../modalStyles.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var AUTO_CLOSE_DELAY = 1000;
var getStars = function getStars(hotel) {
  return R.call(R.pipe(function (_ref) {
    var stars = _ref.stars,
      secondaryStars = _ref.secondaryStars;
    return [stars, secondaryStars];
  }, R.filter(Boolean), R.map(function (stars) {
    return "".concat(stars, " *");
  }), R.join(' / ')), hotel);
};
var IS_NOT_ADDED = false;
var AddHotelToCollectionsModal = function AddHotelToCollectionsModal(_ref2) {
  var countryID = _ref2.countryID,
    hotelID = _ref2.hotelID,
    _onClose = _ref2.onClose;
  var hotelSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getHotel)(), [hotelID]);
  }, [hotelID]);
  var hotel = (0, _reactRedux.useSelector)(hotelSelector);
  var collections = (0, _reactRedux.useSelector)(_selectors2.getCollectionsForAddHotel);
  var fetchCollectionsUI = (0, _reactRedux.useSelector)(_selectors2.getFetchCollectionsUI);
  var addHotelToCollectionUI = (0, _reactRedux.useSelector)(_selectors2.getAddHotelToCollectionUI);
  var _addHotelToCollection = addHotelToCollectionUI.success,
    addedHotelSuccess = _addHotelToCollection === void 0 ? IS_NOT_ADDED : _addHotelToCollection,
    addedHotelFailed = addHotelToCollectionUI.error,
    addedHotelErrorMessage = addHotelToCollectionUI.message;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('ADD_HOTEL_TO_COLLECTIONS_MODAL'),
    t = _useTranslation.t;
  var hotelName = (0, _react.useMemo)(function () {
    return R.concat("".concat(hotel.name, " "), getStars(hotel));
  }, [hotel]);
  var handleAddHotelToCollection = function handleAddHotelToCollection(collectionID) {
    return dispatch((0, _actions2.addHotelToCollection)(hotelID, collectionID));
  };
  var isNeedToShowBtn = !addedHotelSuccess && !addedHotelFailed;
  (0, _react.useEffect)(function () {
    dispatch((0, _actions2.getCollections)());
    return function () {
      return dispatch((0, _actions2.clearCollections)()), dispatch((0, _actions.unRegister)(_constants.ADD_HOTEL_TO_COLLECTION_UI_KEY));
    };
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    if (addedHotelSuccess) {
      setTimeout(function () {
        return _onClose(addedHotelSuccess);
      }, AUTO_CLOSE_DELAY);
    }
  }, [addedHotelSuccess, _onClose]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    className: _modalStyles.default.collectionsModal,
    closeIcon: !addedHotelSuccess,
    onClose: function onClose() {
      return _onClose(addedHotelSuccess);
    }
  }, !addedHotelSuccess && /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: _modalStyles.default.header
  }, (0, _html.decodeHTMLEntities)(t('TITLE', {
    hotelName: hotelName
  }))), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    className: _modalStyles.default.content
  }, (fetchCollectionsUI.loading || addHotelToCollectionUI.loading) && /*#__PURE__*/_react.default.createElement(_Loader.default, {
    inverted: true,
    label: t(addHotelToCollectionUI.loading ? 'ADDING_HOTEL_TO_COLLECTION' : 'DOWNLOADING_COLLECTIONS')
  }), R.isEmpty(addHotelToCollectionUI) && (fetchCollectionsUI.completed && R.isEmpty(collections) ? t('EMPTY_STATE') : /*#__PURE__*/_react.default.createElement(_List.default, null, R.map(function (_ref3) {
    var id = _ref3.id,
      hotels = _ref3.hotels,
      name = _ref3.name,
      type = _ref3.type;
    var isSetHotel = R.any(function (ownHotel) {
      return ownHotel.id === hotelID;
    }, hotels);
    return /*#__PURE__*/_react.default.createElement(_Collection.default, {
      disabled: isSetHotel,
      hotels: hotels,
      key: id,
      name: name,
      type: type,
      onClick: !isSetHotel ? function () {
        return handleAddHotelToCollection(id);
      } : undefined
    });
  }, collections))), addedHotelSuccess && /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.addMessage
  }, t('SUCCESS_ADDED_HOTEL_TO_COLLECTION')), addedHotelFailed && /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.addMessage
  }, addedHotelErrorMessage), isNeedToShowBtn && /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.createButtonContainer
  }, /*#__PURE__*/_react.default.createElement(_CreateCollectionButton.default, {
    countryID: countryID,
    hotelID: hotelID
  }))));
};
var _default = exports.default = (0, _react.memo)(AddHotelToCollectionsModal);